import { CECustomLogicRequirementAttributesBase } from './ce-custom-logic-requirement-attributes-base'


export class CECustomLogicRequirementAttributes extends CECustomLogicRequirementAttributesBase {

}